import React, { useCallback, useState } from "react";
import SuccesForm from "./SuccesForm";
import UserForm from "./UserForm";
import Card from "./footer-card/Card";
import FooterSolutionCard from "./footer-solutions-card/FooterSolutionCard";
import APIDocsForm from "./Modals/ApiDocsForm/APIDocsForm";
import ApiDocsCard from "./apiDocsCard/ApiDocsCard";
import CertificateCard from "./CertificateCard";

const s3url = process.env.REACT_APP_S3_URL;

const certificateCardsData = [
  {
    imgSrc: `${s3url}/cisa.svg`,
    altText: "",
    beforeBreak: "CISA Certified",
    afterBreak: "2022",
  },
  {
    imgSrc: `${s3url}/iso.svg`,
    altText: "",
    beforeBreak: "ISO 27001:2022 ",
    afterBreak: "Certified",
  },
  {
    imgSrc: `${s3url}/fintechaward.svg`,
    altText: "",
    beforeBreak: "Fintech Innovation of ",
    afterBreak: "the Year - Winner",
  },
];
const footerCardsData = [
  {
    apiName: "MSME/Udyam Details",
    apiNameStyles: { color: "#5171D4" },
    imageUrl: "/images/footerimageOne.svg",
    backgroundColor: "#EDF1FF",
  },
  {
    apiName: "LPG Verification",
    apiNameStyles: { color: "#B31416" },
    imageUrl: "/images/footerCardImagetwo.svg",
    backgroundColor: "#FFF6F6",
  },
  {
    apiName: "Mobile to ESIC",
    apiNameStyles: { color: "#F9A63C" },
    imageUrl: "/images/footerCardImageThree.svg",
    backgroundColor: "#FFF4E6",
  },
  {
    apiName: "Aadhaar Verification",
    apiNameStyles: { color: "#B31416" },
    imageUrl: "/images/footerCardImageFour.svg",
    backgroundColor: "#FFFBE8",
  },
  {
    apiName: "Telco Details",
    apiNameStyles: { color: "#A560E8" },
    imageUrl: "/images/footerCardImageFive.svg",
    backgroundColor: "#F8F0FF",
  },
  {
    apiName: "Document OCR",
    apiNameStyles: { color: "#7E40FD" },
    imageUrl: "/images/footerCardImageSix.svg",
    backgroundColor: "#F3EFFD",
  },
  {
    apiName: "Mobile Lookup",
    apiNameStyles: { color: "#002EBC" },
    imageUrl: "/images/footerCardImageSeven.svg",
    backgroundColor: "#D8E2FF",
  },
  {
    apiName: "Employment History",
    apiNameStyles: { color: "#479324" },
    imageUrl: "/images/footerCardImageEight.svg",
    backgroundColor: "#F7FFE1",
  },
  {
    apiName: "RC Details",
    apiNameStyles: { color: "#027A92" },
    imageUrl: "/images/footerCardImageNine.svg",
    backgroundColor: "#E3F9FC",
  },
  {
    apiName: "Digital Payment ID",
    apiNameStyles: { color: "#6D2FEC" },
    imageUrl: "/images/footerCardImageTen.svg",
    backgroundColor: "#F3EFFD",
  },
];

function Footer() {
  const [isUserApplied, setIsUserApplied] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleredirection = useCallback((key) => {
    let externalUrl = {
      apidocs: "https://api.befisc.com",
      newsletter:
        "https://takh7ucwgg0.typeform.com/to/kG2iZbDL?typeform-source=www.linkedin.com",
    };

    window.open(externalUrl[key], "_blank", "noopener,noreferrer");
  }, []);

  return (
    <footer className="footer-wrapper">
      <div className="footer-images">
        <FooterSolutionCard />
        <ApiDocsCard
          imgSrc={"/images/apidoc.svg"}
          text={"API Docs"}
          onclick={() => setIsModalOpen(true)}
        />
        <ApiDocsCard
          imgSrc={"/images/newsletter-footer.svg"}
          text={"Newsletter"}
          onclick={() => handleredirection("newsletter")}
        />
      </div>
      <div className="awards-section-container">
        <div className="awards-section-main">
          <p className="awards-section-heading">
            Leading the Future,{" "}
            <span>Empowered by Certifications & Awards</span>
          </p>
          <div className="awards-section-image-groups">
            {certificateCardsData.map((cert) => (
              <CertificateCard
                imgAltMessage={cert.altText}
                imgSrc={cert.imgSrc}
                beforeBreak={cert.beforeBreak}
                afterBreak={cert.afterBreak}
                key={cert.beforeBreak}
              />
            ))}
          </div>
        </div>
      </div>
      {/* forms and cto details */}
      <div className="footer-form">
        <img
          src={`${s3url}/ctodetailsimage.png`}
          alt="cto_images"
          className="cto-details-img"
          loading="lazy"
          decoding="async"
        />
        {isUserApplied ? (
          <SuccesForm />
        ) : (
          <UserForm userApplied={setIsUserApplied} />
        )}
      </div>
      <div className="footer-copyrights">
        <div className="footer-builtwith">Built with Trust</div>
        <div
          style={{ display: "flex", flexDirection: "column", gap: "2.1rem" }}
        >
          <div className="footer-links" style={{ cursor: "pointer" }}>
            <a href="/term&condition">T&C and Privacy Policy</a>
          </div>
          <div className="footer-rights">
            <p>© {new Date().getFullYear()} All rights reserved</p>
            <p>
              HQ: 3rd Floor, Tower C, The Iconic Corenthum Building, Sector 62,
              Noida, U.P. - 201301
            </p>
            <p className="contact-info">
              <span>Contact Us: Email - shobhit@befisc.com |</span>
              <span>Mobile - 95827 73885</span>
            </p>
          </div>
        </div>
      </div>

      <div className="flex-cards-footer">
        {footerCardsData.map((cardData, index) => (
          <Card
            key={index}
            apiName={cardData.apiName}
            apiNameStyles={cardData.apiNameStyles}
            imageUrl={cardData.imageUrl}
            backgroundColor={cardData.backgroundColor}
          />
        ))}
      </div>

      <APIDocsForm
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        key={"footer-modal"}
      />
    </footer>
  );
}

export default React.memo(Footer);
